import { z } from 'zod';

export const FirefighterSchema = z.object({
  name: z.string().min(1, 'Name is required').max(120),
  surname: z.string().min(1, 'Surname is required').max(120),
  note: z.string().max(2000).optional().default(''),

  // Reference only — nothing else in the app reads these yet. The backend
  // returns them to admin tiers only (utils/firefighter_privacy.py), so a
  // non-admin editing a firefighter sees them blank and must not be able
  // to blank the stored values by saving — see FirefighterEdit.
  contact: z.string().max(200).optional().default(''),
  address: z.string().max(500).optional().default(''),
  emergency_contact: z.string().max(200).optional().default(''),
  medical_aid_details: z.string().max(500).optional().default(''),
});

export type FirefighterValues = z.infer<typeof FirefighterSchema>;
